import React from "react";
import { useState, useEffect } from "react";
import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import ConfirmationModal from "../../fragments/ConfirmationModal";
import { UserContext } from "../../services/user";
import { MESSAGES } from "../../utils/messagesUtils";
import folder from "../../../assets/img/folder.svg";
import ModalAgregarACarpeta from "./fragments/ModalAgregarACarpeta";
import IconSelect from '../../../assets/icons/tresPuntosVertical.svg'
import {ReactComponent as VerCarpetaIcon} from '../../../assets/icons/arrowInsideFolder.svg'
import GeneralDropdown from "../../fragments/Dropdowns/GeneralDropdown";
import { getUmaEnUso, actualizarLiberada } from "../../services/api";
import NimbusModal from "../../fragments/NimbusModal";
import { toast } from 'react-toastify';
import alertConfiguration from "../../utils/alertsUtils";
import ActiveIcon from "../../../assets/icons/activeIcon.svg";
import InactiveIcon from "../../../assets/icons/inactiveIcon.svg";

const ReactivoCard = ({ uma, formatearFecha, clonarUma, modalbook, handleDelete, navigateToConstructorLayout, reload, seleccionadosParaMover, handleCheckContenido, examen = false, buscadorActivo = {}, navegarACarpeta, onToggleLiberada }) => {
  let navigate = useNavigate();
  const { user, activeRole } = useContext(UserContext);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [copyConfirmation, setCopyConfirmation] = useState(false);
  const [agregarACarpeta, setAgregarACarpeta] = useState(false);
  const [dropdownActive, setDropdownActive] = useState(false);
  const [modalEnUso, setModalEnUso] = useState(false);
  const [usuarioEditandoModal, setUsuarioEditandoModal] = useState('');
  const [lockExpirado, setLockExpirado] = useState(false);
  const [minutosRestantes, setMinutosRestantes] = useState(0);
  const [esLiberada, setEsLiberada] = useState(uma.esLiberada !== false);

  useEffect(() => {
    setEsLiberada(uma.esLiberada !== false);
  }, [uma.esLiberada]);

  const handleToggleLiberada = async (e) => {
    e.stopPropagation();
    const nuevoEstado = !esLiberada;
    setEsLiberada(nuevoEstado);
    const res = await actualizarLiberada(uma._id, { esLiberada: nuevoEstado });
    if (res?.response) {
      toast.success(`Lección ${nuevoEstado ? "activada" : "desactivada"} correctamente`, alertConfiguration);
      onToggleLiberada?.(uma._id, nuevoEstado);
    } else {
      setEsLiberada(!nuevoEstado);
      toast.error("Hubo un problema al actualizar el estado de la lección", alertConfiguration);
    }
  };

  const CardOptions = () =>{
    return(
      <div className="bg-white p-2 rounded-md border border-[#dcdcdc] flex custom-dropdown-container z-10">
      {reload && <button onClick={() => setAgregarACarpeta(true)} title="Agregar a carpeta" className="dropdown-item">
          <img className={'fondo-azul-folder w-6 mb-1'} src={folder} alt="" />
          <div className="ml-1 text-sm">Añadir a carpeta</div>
          </button>}
          {activeRole !== 'PROFESOR' && 
          <div className="dropdown-item" onClick={() => setCopyConfirmation(true)} title="Duplicar">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-nimbus col-span-1 cursor-pointer"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
              />
            </svg>
            <div className="ml-1 text-sm">Duplicar</div>
          </div>}
{/*           {activeRole === "AUTOR_ESCOLAR" && uma.origen === "EDITORIAL" && uma.creador.id !== user._id ? (
            <button title="Eliminar">
              <span
                title="Eliminar"
                onClick={() => setDeleteConfirmation(true)}
                className="h-7 w-full cursor-pointer dropdown-item"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="min-w-[24px] w-6 h-6 text-nimbus col-span-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
                <div className="ml-1 text-sm">Eliminar</div>
              </span>
            </button>
          ) : null} */}
          {activeRole === "AUTOR_EDITORIAL" && uma.creador.id === user._id ? (
            <>
              <Link to={`/constructor/UmaConfiguration/${uma._id}`} className="dropdown-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-nimbus col-span-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                  />
                </svg>
                <div className="ml-1 text-sm">Editar campos</div>
              </Link>
              {activeRole === "EDITOR_EDITORIAL" && uma.esPlantilla && !uma.esEliminado && (
              <span
                title="Duplicar plantilla"
                onClick={() => navigate(`/constructor/duplicarPlantilla/${uma._id}`)}
                className="py-1 cursor-pointer dropdown-item"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-nimbus col-span-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                  />
                </svg>
                <div className="ml-1 text-sm">Duplicar plantilla</div>
              </span>
              )}
              <span
                onClick={() => setDeleteConfirmation(true)}
                className="w-full py-1 cursor-pointer mr-4 dropdown-item"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="min-w-[24px] w-6 h-6 text-nimbus col-span-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
                <div className="ml-1 text-sm">Eliminar</div>
              </span>
            </>
          ) : null}
          {activeRole !== "AUTOR_EDITORIAL" && (
            <>
              {activeRole === "AUTOR_ESCOLAR" && uma.origen === "EDITORIAL" ? null : (
                <>
                  <Link to={`/constructor/UmaConfiguration/${uma._id}`} state={{esExamen: examen}} className="dropdown-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-nimbus col-span-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                      />
                    </svg>
                    <div className="ml-1 text-sm">Editar campos</div>
                  </Link>
                  {activeRole === "EDITOR_EDITORIAL" && uma.esPlantilla && !uma.esEliminado && (
                  <span
                    title="Duplicar plantilla"
                    onClick={() => navigate(`/constructor/duplicarPlantilla/${uma._id}`)}
                    className="py-1 cursor-pointer dropdown-item"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-nimbus col-span-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                    <div className="ml-1 text-sm">Duplicar plantilla</div>
                  </span>
                  )}
                  <span
                    onClick={() => setDeleteConfirmation(true)}
                    className="rounded-full w-7 h-7 py-1 cursor-pointer mr-4 dropdown-item"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="min-w-[24px] w-6 h-6 text-nimbus col-span-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                    <div className="ml-1 text-sm">Eliminar</div>
                  </span>
                </>
              )}
            </>
          )}
          {(buscadorActivo?.estatus && buscadorActivo?.esGeneral) && (
            <button type="button" className="flex items-center" onClick={() => navegarACarpeta(uma)}>
              <VerCarpetaIcon className="h-6 w-6"/>
              <span className=" ml-1 text-sm">Abrir carpeta</span>
            </button>
          )}
      </div>
    )
  }

  const toggleDropdown = () => setDropdownActive(!dropdownActive)

  const handleClickCard = async () => {
    if (activeRole !== 'EDITOR_EDITORIAL') {
      navigateToConstructorLayout(uma);
      return;
    }
    const nombreActual = [user.nombres, user.primerApellido, user.segundoApellido].filter(Boolean).join(' ');
    const res = await getUmaEnUso(uma._id);
    const { esUsada, usuarioEditando, fechaActualizacion, fechaBloqueo } = res?.response?.data || {};
    if (esUsada && usuarioEditando && usuarioEditando !== nombreActual) {
      const unaHora = 60 * 60 * 1000;
      const ahora = new Date();
      const actualizacionExpirada = fechaActualizacion && (ahora - new Date(fechaActualizacion)) > unaHora;
      const bloqueoExpirado = !fechaBloqueo || (ahora - new Date(fechaBloqueo)) > unaHora;
      const masDeUnaHora = actualizacionExpirada && bloqueoExpirado;
      const fechas = [fechaActualizacion && new Date(fechaActualizacion), fechaBloqueo && new Date(fechaBloqueo)].filter(Boolean);
      const fechaMasReciente = fechas.length > 0 ? new Date(Math.max(...fechas)) : null;
      const msRestantes = fechaMasReciente ? Math.max(0, fechaMasReciente.getTime() + unaHora - ahora.getTime()) : 0;
      setMinutosRestantes(Math.ceil(msRestantes / 60000));
      setUsuarioEditandoModal(usuarioEditando);
      setLockExpirado(masDeUnaHora);
      setModalEnUso(true);
      return;
    }
    navigateToConstructorLayout(uma);
  };

  return (
    <div key={uma._id} className="w-80 mb-4">
      <div
        className={`${
          uma.origen === "EDITORIAL" && user._id !== uma.creador._id && activeRole === "AUTOR_ESCOLAR"
            ? "border-b-4 border-b-[#AF0101]"
            : "border"
        } h-40 rounded-lg p-2 relative pl-5 border border-[#ededed] flex flex-col`}
      >
        <div
          title="Editar contenidos"
          className="py-2 cursor-pointer"
          onClick={handleClickCard}
        >
          <div className="col-span-5">
            <div className="flex w-auto justify-between">
              {uma.esPlantilla && (<span className="absolute left-2 bg-blue-400 text-white text-xs font-bold px-1 py-1 mt-2 ml-0.5 rounded-full shadow"></span>)}
            <p className="text-nimbus justify-start font-bold truncate mr-4">{uma.titulo}</p> 
            </div>
            <p className="truncate">{uma.descripcion}</p>
          </div>
        </div>
        <div className="absolute col-span-1 top-2 right-2">
          <input checked={seleccionadosParaMover?.includes(uma?._id)} type="checkbox" name="checkUserAdd" id={uma._id} onChange={handleCheckContenido} className='h-5 w-5 text-[#1A3D82] border-[#1A3D82] rounded-md justify-end'/>
        </div>
        <div className={`absolute w-2 h-full left-0 top-0 rounded-l-lg  ${uma.umaTipo === 'Examen' ? 'bg-gradient-to-b from-[#cb3f24] to-[#ffc616]' : 'bg-gradient-to-b from-[#AF0101] to-[#FA9EF1]'}`}></div>
        {/* `mt-auto` y no un margen fijo: la descripción puede venir vacía, y con
            un `mt-8` la tarjeta perdía ese renglón y el pie subía. Así el pie
            queda pegado abajo y todas las tarjetas se ven a la misma altura. */}
        <div className="relative flex items-end justify-between gap-1 mt-auto">
          <div className="min-w-0 flex-1">
            <p className="text-xs">{formatearFecha(uma.fechaCreacion)}</p>
            <p>{uma.creador ? uma.creador.nombres : user.nombres}</p>
          </div>
          <div className="flex items-center gap-1 shrink-0">
            {/* EN ESPERA PARA INTEGRAR CARPETAS DE EXAMEN */}
            <GeneralDropdown
              open={dropdownActive}
              children={<CardOptions/>}
              toggleDropdown={toggleDropdown}
              dropdownStyles={'absolute bottom-0 right-[150px]'}
            />
            {(activeRole === "EDITOR_EDITORIAL" || activeRole === "AUTOR_INDEPENDIENTE") && (
              <button
                title={esLiberada ? "Desactivar lección" : "Activar lección"}
                onClick={handleToggleLiberada}
              >
                <img src={esLiberada ? ActiveIcon : InactiveIcon} className="h-6 w-6" alt="" />
              </button>
            )}
            <svg
              onClick={() => modalbook(uma._id)}
              xmlns="http://www.w3.org/2000/svg"
              className="h-7 w-7 text-nimbus cursor-pointer"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              />
            </svg>
            <div className="w-6 h-6 relative">
              <img
                src={IconSelect}
                className="cursor-pointer absolute top-0 left-0 right-0 bottom-0"
                onClick={()=>setDropdownActive(!dropdownActive)}
              />
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        isOpen={deleteConfirmation}
        setIsOpen={setDeleteConfirmation}
        handleAction={() => handleDelete(uma._id, "Evaluación")}
        action="Eliminar"
        messages={activeRole === "PROFESOR" ? MESSAGES.MESSAGE_ELIMINAR_EXAMEN : MESSAGES.MESSAGE_ELIMINAR_EVALUACION}
      />
      <ConfirmationModal
        isOpen={copyConfirmation}
        setIsOpen={setCopyConfirmation}
        handleAction={() => clonarUma(uma, "Evaluación")}
        action="Duplicar"
        messages={activeRole === 'PROFESOR' ? MESSAGES.MESSAGE_COPIAR_EXAMEN : uma.origen === "EDITORIAL" && activeRole === "AUTOR_ESCOLAR" ? MESSAGES.MESSAGE_COPIAR_EVALUACION_PRIMIGENIO : MESSAGES.MESSAGE_COPIAR_EVALUACION}
      />
      <ModalAgregarACarpeta
        idUma={uma._id}
        isOpen={agregarACarpeta}
        setIsOpen={setAgregarACarpeta}
        reload={reload}
      />
      <NimbusModal
        isOpen={modalEnUso}
        variant="warning"
        title="Contenido en edición"
        onRequestClose={() => setModalEnUso(false)}
        onCancel={lockExpirado ? () => setModalEnUso(false) : null}
        cancelText="Cerrar"
        onConfirm={lockExpirado ? () => { setModalEnUso(false); navigateToConstructorLayout(uma); } : () => setModalEnUso(false)}
        confirmText={lockExpirado ? "Entrar de todas formas" : "Aceptar"}
      >
        <p className="text-gray-500 mb-1">
          Este contenido está siendo editado por <span className="font-semibold text-gray-700">{usuarioEditandoModal}</span>.
        </p>
        <p className="text-gray-500">
          {lockExpirado
            ? `Este contenido lleva más de una hora sin actividad. Comunícate con ${usuarioEditandoModal} para verificar si sigue editando.`
            : <>Podrás editarlo cuando termine. Tiempo estimado de desbloqueo: <span className="font-semibold text-gray-700">{minutosRestantes <= 1 ? 'menos de 1 minuto' : `${minutosRestantes} minutos`}</span>.</>
          }
        </p>
      </NimbusModal>
    </div>
  );
};

export default ReactivoCard;
